export const localization = {
  pt: {
    at: 'às',
    by: 'Por',
    addContentButton: 'Adicionar conteúdo',
    importFileButton: 'Importar arquivo',
    addUrlButton: 'Adicionar URL',
    documentMoreOptions: {
      open: 'Abrir',
      download: 'Baixar',
      update: 'Atualizar',
      restore: 'Restaurar',
      deactivate: 'Desativar',
      activate: 'Ativar',
      delete: 'Excluir',
    },
    deleteDocumentAlert: {
      body: 'Ao excluir este arquivo, os Agentes de IA poderão perder referências importantes para algumas respostas.<br/><br/>Deseja excluir mesmo assim?',
      buttons: {
        cancel: 'Cancelar',
        confirm: 'Excluir',
      },
      title: 'Excluir conteúdo',
    },
    emptyState: {
      subtitle: 'Para começar, importe um arquivo ou adicione uma URL para o catálogo',
      title: 'Ainda não há conteúdos',
    },
    errorActivateDocumentToast: {
      message: 'Não foi possível ativar o conteúdo. Tente novamente.',
      title: 'Falha ao ativar o conteúdo',
    },
    errorDeactivateDocumentToast: {
      message: 'Não foi possível desativar o conteúdo. Tente novamente.',
      title: 'Falha ao desativar o conteúdo',
    },
    errorDeleteDocumentToast: {
      message: 'Não foi possível excluir o documento. Tente novamente.',
      title: 'Falha ao excluir documento',
    },
    errorDownloadDocumentToast: {
      message: 'Não foi possível restaurar o conteúdo. Tente novamente.',
      title: 'Falha ao baixar o conteúdo',
    },
    errorCatalogNameUpdateToast: {
      message: 'Não foi possível atualizar o nome do catálogo. Tente novamente.',
      title: 'Falha ao atualizar catálogo',
    },
    headerContent: 'Configurar catálogo',
    searchPlaceholder: 'Pesquisar',
    subtitle: 'Centralize documentos, links e artigos para que o agente tenha acesso ao conhecimento necessário.',
    successActivateDocumentToast: {
      message: 'O conteúdo foi ativado e está disponível no catálogo.',
      title: 'Conteúdo ativado',
    },
    successDeactivateDocumentToast: {
      message: 'O conteúdo foi desativado e está indisponível no catálogo.',
      title: 'Conteúdo desativado',
    },
    successDeleteDocumentToast: {
      message: 'O documento foi excluído do catálogo.',
      title: 'Documento excluído',
    },
    successDownloadDocumentToast: {
      message: 'O conteúdo foi baixado no seu dispositivo.',
      title: 'Conteúdo baixado',
    },
    SuccessCatalogNameUpdatedToast: {
      message: 'O nome do catálogo foi atualizado com sucesso.',
      title: 'Catálogo atualizado',
    },
    tableHeaders: {
      content: 'Conteúdo',
      lastUpdate: 'Última atualização',
      synchronization: 'Sincronização',
    },
    title: 'Configurar catálogo',
    syncStatus: {
      processing: 'Sincronizando',
      active: 'Ativo',
      inactive: 'Inativo',
      failed: 'Erro',
    },
    toastFileErrors: {
      unsupportedFileType: {
        title: 'Formato inválido',
        message: 'O arquivo não está em um formato suportado. Converta para um formato válido e tente novamente.',
      },
      pdfLoadingError: {
        title: 'Falha na leitura do PDF',
        message: 'Não foi possível processar o PDF enviado. Envie um PDF válido e tente novamente.',
      },
      emptyFile: {
        title: 'Arquivo vazio',
        message: 'O arquivo não possui conteúdo. Verifique o arquivo e tente novamente.',
      },
      fileFormattingError: {
        title: 'Falha na formatação do arquivo',
        message: 'O arquivo possui problemas de estrutura. Revise a formatação e tente novamente.',
      },
      missingTextColumn: {
        title: 'Erro na coluna do arquivo',
        message: 'O arquivo não contém a coluna text. Ajuste as colunas obrigatórias e tente novamente.',
      },
    },
    toastUrlErrors: {
      notfound: {
        title: 'URL não encontrada',
        message: 'Não foi possível localizar a URL informada. Insira uma URL válida e tente novamente.',
      },
      blocked: {
        title: 'URL bloqueada',
        message: 'O acesso à URL foi bloqueado devido a restrições ou políticas de privacidade impostas pelo proprietário.',
      },
    },
  },
  en: {
    at: 'at',
    by: 'By',
    addContentButton: 'Add content',
    importFileButton: 'Import file',
    addUrlButton: 'Add URL',
    documentMoreOptions: {
      open: 'Open',
      download: 'Download',
      update: 'Update',
      restore: 'Restore',
      deactivate: 'Deactivate',
      activate: 'Activate',
      delete: 'Delete',
    },
    deleteDocumentAlert: {
      body: 'By deleting this file, AI Agents may lose important references for some responses.<br/><br/>Do you want to delete it anyway?',
      buttons: {
        cancel: 'Cancel',
        confirm: 'Delete',
      },
      title: 'Delete content',
    },
    emptyState: {
      subtitle: 'To get started, import a file or add a URL to the catalog',
      title: 'No content yet',
    },
    errorActivateDocumentToast: {
      message: 'Could not activate the content. Please try again.',
      title: 'Failed to activate content',
    },
    errorDeactivateDocumentToast: {
      message: 'Could not deactivate the content. Please try again.',
      title: 'Failed to deactivate content',
    },
    errorDeleteDocumentToast: {
      message: 'Could not delete the document. Please try again.',
      title: 'Failed to delete document',
    },
    errorDownloadDocumentToast: {
      message: 'Could not download the content. Please try again.',
      title: 'Failed to download content',
    },
    errorCatalogNameUpdateToast: {
      message: 'Could not update the catalog name. Please try again.',
      title: 'Failed to update catalog',
    },
    headerContent: 'Configure catalog',
    searchPlaceholder: 'Search',
    subtitle: 'Centralize documents, links and articles so the agent has access to the necessary knowledge.',
    successActivateDocumentToast: {
      message: 'The content has been activated and is available in the catalog.',
      title: 'Content activated',
    },
    successDeactivateDocumentToast: {
      message: 'The content has been deactivated and is unavailable in the catalog.',
      title: 'Content deactivated',
    },
    successDeleteDocumentToast: {
      message: 'The document has been deleted from the catalog.',
      title: 'Document deleted',
    },
    successDownloadDocumentToast: {
      message: 'The content has been downloaded to your device.',
      title: 'Content downloaded',
    },
    SuccessCatalogNameUpdatedToast: {
      message: 'The catalog name has been successfully updated.',
      title: 'Catalog updated',
    },
    tableHeaders: {
      content: 'Content',
      lastUpdate: 'Last update',
      synchronization: 'Synchronization',
    },
    title: 'Configure catalog',
    syncStatus: {
      processing: 'Synchronizing',
      active: 'Active',
      inactive: 'Inactive',
      failed: 'Failed',
    },
    toastFileErrors: {
      unsupportedFileType: {
        title: 'Invalid format',
        message: 'The file is not in a supported format. Convert to a valid format and try again.',
      },
      pdfLoadingError: {
        title: 'PDF reading failed',
        message: 'Could not process the uploaded PDF. Upload a valid PDF and try again.',
      },
      emptyFile: {
        title: 'Empty file',
        message: 'The file has no content. Check the file and try again.',
      },
      fileFormattingError: {
        title: 'File formatting failed',
        message: 'The file has structural problems. Review the formatting and try again.',
      },
      missingTextColumn: {
        title: 'File column error',
        message: 'The file does not contain the text column. Adjust the required columns and try again.',
      },
    },
    toastUrlErrors: {
      notfound: {
        title: 'URL not found',
        message: 'Could not locate the provided URL. Please enter a valid URL and try again.',
      },
      blocked: {
        title: 'URL blocked',
        message: 'Access to the URL has been blocked due to restrictions or privacy policies imposed by the owner.',
      },
    },
  },
  es: {
    at: 'a las',
    by: 'Por',
    addContentButton: 'Agregar contenido',
    importFileButton: 'Importar archivo',
    addUrlButton: 'Agregar URL',
    documentMoreOptions: {
      open: 'Abrir',
      download: 'Descargar',
      update: 'Actualizar',
      restore: 'Restaurar',
      deactivate: 'Desactivar',
      activate: 'Activar',
      delete: 'Eliminar',
    },
    deleteDocumentAlert: {
      body: 'Al eliminar este archivo, los Agentes de IA podrían perder referencias importantes para algunas respuestas.<br/><br/>¿Desea eliminarlo de todos modos?',
      buttons: {
        cancel: 'Cancelar',
        confirm: 'Eliminar',
      },
      title: 'Eliminar contenido',
    },
    emptyState: {
      subtitle: 'Para comenzar, importe un archivo o agregue una URL al catálogo',
      title: 'Aún no hay contenido',
    },
    errorActivateDocumentToast: {
      message: 'No se pudo activar el contenido. Inténtalo de nuevo.',
      title: 'Error al activar contenido',
    },
    errorDeactivateDocumentToast: {
      message: 'No se pudo desactivar el contenido. Inténtalo de nuevo.',
      title: 'Error al desactivar contenido',
    },
    errorDeleteDocumentToast: {
      message: 'No se pudo eliminar el documento. Inténtalo de nuevo.',
      title: 'Error al eliminar documento',
    },
    errorDownloadDocumentToast: {
      message: 'No se pudo descargar el contenido. Inténtalo de nuevo.',
      title: 'Error al descargar contenido',
    },
    errorCatalogNameUpdateToast: {
      message: 'No se pudo actualizar el nombre del catálogo. Inténtalo de nuevo.',
      title: 'Error al actualizar catálogo',
    },
    headerContent: 'Configurar catálogo',
    searchPlaceholder: 'Buscar',
    subtitle: 'Centralice documentos, enlaces y artículos para que el agente tenga acceso al conocimiento necesario.',
    successActivateDocumentToast: {
      message: 'El contenido ha sido activado y está disponible en el catálogo.',
      title: 'Contenido activado',
    },
    successDeactivateDocumentToast: {
      message: 'El contenido ha sido desactivado y está indisponible en el catálogo.',
      title: 'Contenido desactivado',
    },
    successDeleteDocumentToast: {
      message: 'El documento ha sido eliminado del catálogo.',
      title: 'Documento eliminado',
    },
    successDownloadDocumentToast: {
      message: 'El contenido ha sido descargado en tu dispositivo.',
      title: 'Contenido descargado',
    },
    SuccessCatalogNameUpdatedToast: {
      message: 'El nombre del catálogo ha sido actualizado con éxito.',
      title: 'Catálogo actualizado',
    },
    tableHeaders: {
      content: 'Contenido',
      lastUpdate: 'Última actualización',
      synchronization: 'Sincronización',
    },
    title: 'Configurar catálogo',
    syncStatus: {
      processing: 'Sincronizando',
      active: 'Activo',
      inactive: 'Inactivo',
      failed: 'Error',
    },
    toastFileErrors: {
      unsupportedFileType: {
        title: 'Formato inválido',
        message: 'El archivo no está en un formato compatible. Convierte a un formato válido e inténtalo de nuevo.',
      },
      pdfLoadingError: {
        title: 'Error al leer PDF',
        message: 'No se pudo procesar el PDF subido. Sube un PDF válido e inténtalo de nuevo.',
      },
      emptyFile: {
        title: 'Archivo vacío',
        message: 'El archivo no tiene contenido. Verifica el archivo e inténtalo de nuevo.',
      },
      fileFormattingError: {
        title: 'Error en el formato del archivo',
        message: 'El archivo tiene problemas de estructura. Revisa el formato e inténtalo de nuevo.',
      },
      missingTextColumn: {
        title: 'Error en la columna del archivo',
        message: 'El archivo no contiene la columna text. Ajusta las columnas obligatorias e inténtalo de nuevo.',
      },
    },
    toastUrlErrors: {
      notfound: {
        title: 'URL no encontrada',
        message: 'No se pudo localizar la URL proporcionada. Ingresa una URL válida e inténtalo de nuevo.',
      },
      blocked: {
        title: 'URL bloqueada',
        message: 'El acceso a la URL ha sido bloqueado debido a restricciones o políticas de privacidad impuestas por el propietario.',
      },
    },
  },
};
